import React, { useState, useMemo, useContext } from 'react';
import {Link, NavLink, useMatch} from "react-router-dom";
import useLocalStorage from "use-local-storage";
import { useCookies } from "react-cookie";
import '../styles/components/menu.scss';
import homeIcon from '../assets/images/icn-house.png';
import plusIcon from '../assets/images/icn-nav-plus-#FF7800.png';
import negativeIcon from '../assets/images/icn-nav-minus.png';
import fetchOptionsBuilder from '../fetchOptionBuilder';
import WorkflowContext from '../workflowContext';

import WorkflowPicker from '../components/WorkflowPicker';

function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }

const menuItems = [
    {
        name: 'Dashboard',
        url: '',
        subNav: [
            {
                name: 'Overview',
                url: ''
            },
            // {
            //     name: 'Strain Detail View',
            //     url: 'strains/detail'
            // }
        ]
    },
    {
        name: 'Strains',
        url: 'strains',
        subNav: [
            {
                name: 'Overview',
                url: 'strains'
            },
            {
                name: 'Query',
                url: 'strains/query'
            }
            // {
            //     name: 'Strain Detail View',
            //     url: 'strains/detail'
            // }
        ]
    },
    {
        name: 'Gene Families',
        url: 'gene-families',
        subNav: [
            {
                name: 'Overview',
                url: 'gene-families'
            },
            // {
            //     name: 'Cluster Detail View',
            //     url: 'gene-families/detail'
            // }
        ]
    },
    // {
    //     name: 'AMR Genes',
    //     url: 'gene-names',
    //     subNav: [
    //         {
    //             name: 'Overview',
    //             url: 'gene-names'
    //         },
    //         {
    //             name: 'Gene Detail View',
    //             url: 'gene-names/detail'
    //         }
    //     ]
    // },
    {
        name: 'Virulence',
        url: 'virulence',
        subNav: [
            {
                name: 'Genes',
                url: 'vf-genes'
            },
            {
                name: 'Heatmap',
                url: 'virulence'
            },
        ]
    },
    {
        name: 'Resistance',
        url: 'resistance',
        subNav: [
            {
                name: 'Genes',
                url: 'gene-names'
            },

            {
                name: 'Heatmap',
                url: 'resistance'
            },
            // {
            //     name: 'Custom Report 1',
            //     url: '/resistance/custom-report-1'
            // }
        ]
    },
    { // Phenotypes not currently implemented
        name: 'Phenotypes',
        url: 'phenotypes',
        subNav: [
            {
                name: 'Overview',
                url: 'phenotypes'
            }
        ]
    },
    {
        name: 'Phylotree',
        url: 'phylotree',
        subNav: [
            {
                name: 'Circular',
                url: 'phylotree'
            },
            {
                name: 'Linear',
                url: 'linearphylotree'
            }
        ]
    },
    {
        name: 'EpiNetwork',
        url: 'epinetwork',
        subNav: [
            {
                name: 'Graph',
                url: 'epinetwork'
            }
        ]
    },
    //commenting the samplemanagement tab as we need to hide for the release
    // {
    //     name: 'Sample Management',
    //     url: '/sampleManage',
    //     subNav: [
    //         {
    //             name: 'Overview',
    //             url: '/sampleManage'
    //         }
    //     ]
    // },
    // {
    //     name: 'Reports',
    //     url: '/reports',
    //     subNav: [
    //         {
    //             name: 'Overview',
    //             url: '/reports'
    //         },
    //         {
    //             name: 'Second tab',
    //             url: '/reports/second-tab'
    //         }
    //     ]
    // },
];

export default function Menu({ setWorkflow }) {
    const [displayItems, setDisplayItems] = useState([]);
    const workflow = useContext(WorkflowContext);
    // const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);

    const [apitoken, setApitoken] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('apitoken', null)
    );

    const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));

    useMemo(() => {
        const newDisplayItems = [];
        let multiqc = false;
        Promise.all([
            fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + "summary/routes", fetchOptionsBuilder(apitoken, workflow, getDataUserId))
                .then(res => {
                    if (!res.ok) throw new Error('database not found');
                    return res.json()
                })
                .then(active => {
                    menuItems.forEach(item => {
                        if (active[item.name]) newDisplayItems.push(item);
                    });
                })
                .catch(err => {
                    console.log('Could not get routes, reverting to default');
                    setDisplayItems(menuItems.filter(item => item.name === 'Sample Management'));
                }),
            fetch(process.env.REACT_APP_WORKFLOW_API_PATH + `wfapi/workflow/${workflow}?userId=${getDataUserId}`, {
                headers: {
                    "Authorization": `Bearer ${ apitoken }`,
                },
            })
                .then(res => res.json())
                .then(wfresult => {
                    if (wfresult.multiQcReport) multiqc = true;
                })
        ])
            .then(() => {
                if (multiqc) newDisplayItems.push({
                    name: 'MultiQc',
                    url: 'multiqc',
                    subNav: [
                        {
                            name: 'Report',
                            url: 'multiqc'
                        }
                    ]
                });
                setDisplayItems(newDisplayItems);
            });
    }, [workflow]);
    let homeMatch = useMatch('/');
    return (
        <div className="position-sticky pt-3 mt-5">
            <ul className={`list-unstyled ps-0 ${window.screen.width <= 1448 && 'pt-5'}`}>
                <div className="menu-home-item-wrapper">

                    <WorkflowPicker setWorkflow={setWorkflow} />

                </div>
                {displayItems.map((item, index) => <MenuItem key={index} data={item}/>)}
            </ul>
        </div>
    );
}

const MenuItem = ({data}) => {
    const [open, setOpen] = useState(false)

    const subNav = data.subNav.map((item, index) =>{
        return <li className='menu-item' key={index}><NavLink  className={`menu-item-link ${({isActive}) => (isActive ? "active" : "")}`}  key={index} to={item.url}>{item.name}</NavLink></li>
    }
);

// console.log(setWorkflow);

    return (
        <li className='menu-total-item'>
            <button className={`btn btn-toggle d-inline-flex align-items-center rounded border-0 collapse top-of-item ${open ? " active" : ""}`}
                    data-bs-toggle="collapse" data-bs-target={`#${data.name.toLowerCase().replace(' ', '')}-collapse`}
                    aria-expanded="false"
                    onClick={() => setOpen(!open)}
                    >
                {data.name}
                {open ? <img className='menu-item-icon negative' src={negativeIcon} alt="-" />
                    : <img className='menu-item-icon' src={plusIcon} alt="+" />}
            </button>
            <div className="collapse submenu-item-wrapper" id={`${data.name.toLowerCase().replace(' ', '')}-collapse`}>
                <ul className="btn-toggle-nav list-unstyled fw-normal submenu-item">
                    {subNav}
                </ul>
            </div>
        </li>
    );
}
